import React,{Component} from 'react'
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import DateTime from 'react-datetime';
import moment from 'moment';
import Overlay from '../../../../presentation/Overlay';
import Comparison from '../../../../prototypes/Comparison';
import './css/JobDialog.css';

class JobDialog extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      mode: props.editMode === undefined ? 'EDIT' : props.editMode,
      row: props.row === undefined ? {"JOB_ID": 0, "ACTIVE": 0} : props.row,
      show: props.show === undefined ? false : this.props.show,
    }
    this.onClose = this.onClose.bind( this );
    this.onSave = this.onSave.bind( this );
    this.onChangeRow = this.onChangeRow.bind( this );
    this.onChangeStartDate = this.onChangeStartDate.bind( this );
    this.onChangeEndDate = this.onChangeEndDate.bind( this );
  };

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = false;

    if( props.show !== undefined ) {
      const compare = new Comparison(props.show, state.show);
      if( compare.isMatch( compare.MatchTypes.Integer ) === false ) {
        newState.show = props.show
        stateChanged = true
      }
    }

    if( props.mode !== undefined ) {
      const compare = new Comparison(props.mode, state.mode);
      if( compare.isMatch( compare.MatchTypes.String ) === false ) {
        newState.mode = props.mode
        stateChanged = true
      }
    }
    if( props.row !== undefined ) {
      const compare = new Comparison( props.row,state.row);
      if( compare.isMatch( compare.MatchTypes.DataRow ) === false ) {
        newState.row = props.row;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }
    return null;
  }

  onClose( e ) {
    if( this.props.onClose !== undefined ) {
      this.props.onClose( e );
    }
  }
  
  onSave( e ) {
    if( this.props.onSave !== undefined ) {
      e.target.mode = this.state.mode;
      e.target.row = this.state.row;
      this.props.onSave( e );
    }
  }

  onChangeRow( e ) {
    let row = this.state.row;
    if( e.target.id === 'ACTIVE' ) {
      if(e.target.checked === true ) {
        row[e.target.id] = 1
      } else {
        row[e.target.id] = 0
      }
    } else {
      row[ e.target.id ] = e.target.value
    }
    this.setState( { 
      row: row
    } );
  }

  onChangeStartDate( dateTime ) {
    let row = this.state.row;
    try{
      row["START_DATE"] = dateTime.format("YYYY-MM-DD HH:mm:ss");  
    } catch (error) {}
    this.setState( { 
      row: row
    } );
  }

  onChangeEndDate( dateTime ) {
    let row = this.state.row;
    try{
      row["END_DATE"] = dateTime.format("YYYY-MM-DD HH:mm:ss"); 
    } catch (error) {}
    this.setState( { 
      row: row
    } );
  }

  onRenderBody() {
    let checked = this.state.row.ACTIVE === 0 ? false : true;
    let startDate = moment(this.state.row.START_DATE).format("YYYY-MM-DD HH:mm:ss");
    let startDateEnabled = this.state.mode === 'NEW' ? true : false;
    let endDate = moment(this.state.row.END_DATE).format("YYYY-MM-DD HH:mm:ss");
    let startDateTimeInput = (
      <DateTime 
        id="START_DATE"
        value={startDate} 
        defaultValue={startDate}
        viewDate={startDate}
        dateFormat="YYYY-MM-DD"
        timeFormat="HH:mm:ss"
        width="100%" 
        onChange={this.onChangeStartDate}
        disableCloseOnClickOutside={false}
      />
    );
    if( startDateEnabled === false ) {
      startDateTimeInput =  (
          <input type="text" disabled={true} 
            id="START_DATE"
            value={startDate} 
            style={{"width":"100%","height":"32px"}}
            enabled={startDateEnabled} 
          />
        );
    }
    return (
      <DialogBody>
        <div className="job-dialog-form">
          <div className="job-dialog-form-row-1">
            <input id="ACTIVE" type="checkbox" checked={checked} onChange={this.onChangeRow} />
            <span>
              Active
            </span>
          </div>
          <div className="job-dialog-form-row-2">
            <div className="job-dialog-form-field">
              <span>
                Name
              </span>
              <input id="NAME" type="textbox" value={this.state.row.NAME} onChange={this.onChangeRow} />
            </div>
            <div className="job-dialog-form-field">
              <span>
                DESCRIPTION
              </span>
              <input id="DESCRIPTION" type="textbox" value={this.state.row.DESCRIPTION}  onChange={this.onChangeRow} />
            </div>
          </div>
          <div className="job-dialog-form-row-3">
            <div className="job-dialog-form-field">
              <span>
                Start Date
              </span>
              {startDateTimeInput}
            </div>
            <div className="job-dialog-form-field">
              <span>
                End Date
              </span>
              <DateTime 
                id="END_DATE"
                value={endDate} 
                defaultValue={endDate}
                viewDate={endDate}
                dateFormat="YYYY-MM-DD"
                timeFormat="HH:mm:ss"
                width="100%" 
                onChange={this.onChangeEndDate}
                disableCloseOnClickOutside={false}
              />
            </div>          
          </div>
          <div className="job-dialog-form-row-4">
            <div className="job-dialog-form-field">
                <span>
                  Interval
                </span>
                <select id="INTERVAL" value={this.state.row.INTERVAL} onChange={this.onChangeRow}>
                  <option value="0">Seconds</option>
                  <option value="1">Minutes</option>
                  <option value="2">Hours</option>
                  <option value="3">Days</option>
                  <option value="4">Weeks</option>
                </select>              
              </div>
              <div className="job-dialog-form-field">
                <span>
                  Frequency
                </span>
                <input id="FREQUENCY" type="textbox" value={this.state.row.FREQUENCY} onChange={this.onChangeRow} />
              </div>          
          </div>
          <div className="job-dialog-form-row-5">
            <div className="job-dialog-form-field">
              <span>
                  Procedure
              </span>
              <input id="PROCEDURE" type="textbox" value={this.state.row.PROCEDURE} onChange={this.onChangeRow} />
            </div>
          </div>
        </div>
      </DialogBody>
    )
  }

  onRenderFooter() {
    return (
      <DialogFooter>
        <button className="dialog-save-button" onClick={this.onClose}>Cancel</button>
        <button className="dialog-save-button" onClick={this.onSave}>Save</button>
      </DialogFooter>
    );
  }
  
  render() { 
    let caption = 'Add New Job';
    if( this.state.row.JOB_ID !== 0 ) {
      caption  = "Edit Job: " + this.state.row.NAME;
    } 
    return (
      <div>
        <Overlay show={this.props.show} />
        <Dialog show={this.props.show} width={55} height={70}>
          <DialogHeader caption={caption} closeButton onClose={this.onClose} onSave={this.onSave} />
          {this.onRenderBody()}
          {this.onRenderFooter()}
        </Dialog>
      </div>
    )
  }
};

export default JobDialog


// WEBPACK FOOTER //
// ./src/content/technical/jobs/components/JobDialog.js